function transformData(data) {
    let menuData;

    // If backend is sending the old style navigation data
    // trasform it so it can be consumed by the refactored components
    if (data.gendered_menus) {
        let types = ["by_category", "by_brand"];

        menuData = data.gendered_menus;

        menuData.forEach((menu) => {
            let combined = types.reduce((acc, type) => {
                return acc.concat(menu[type].categories);
            }, []);

            menu.menus = combined.filter((category) => {
                return category.single_link === null;
            });

            menu.links = combined.filter((category) => {
                return category.single_link !== null;
            });
        });
    } else {
        menuData = [data.F, data.M];
    }

    return menuData;
}

export default transformData;
